import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import types from '../types';
import notification from '../../services/notification';

function* getVoteProjects({ payload }) {
  try {
    const { data, status } = yield call(api.vote.getVotingProjects, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_VOTE_PROJECTS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_VOTE_PROJECTS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* getSingleVoteProject({ payload }) {
  try {
    const { data, status } = yield call(api.vote.getSingleVoteProject, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_SINGLE_VOTE_PROJECT_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_SINGLE_VOTE_PROJECT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* createVoteProject({ payload, callback }) {
  try {
    const { data, status } = yield call(api.vote.createVoteProject, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.POST_CREATE_VOTE_PROJECT_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.POST_CREATE_VOTE_PROJECT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updateVoteProject({ payload, callback }) {
  try {
    const { status } = yield call(api.vote.updateVoteProject, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_VOTE_PROJECT_SUCCESS });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.UPDATE_VOTE_PROJECT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* deleteVoteProject({ payload }) {
  try {
    const { status } = yield call(api.vote.deleteVoteProject, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.DELETE_VOTE_PROJECT_SUCCESS, payload: payload.id });
  } catch (error) {
    yield put({ type: types.DELETE_VOTE_PROJECT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* createVoteProjectContent({ payload, callback }) {
  try {
    const { data, status } = yield call(api.vote.createVoteProjectContent, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.CREATE_VOTE_PROJECT_CONTENT_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.CREATE_VOTE_PROJECT_CONTENT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updateVoteProjectContent({ payload, callback }) {
  try {
    const { data, status } = yield call(api.vote.updateVoteProjectContent, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_VOTE_PROJECT_CONTENT_SUCCESS, payload: data });
    notification({ type: 'success', message: 'Success' });
    callback();
  } catch (error) {
    yield put({ type: types.UPDATE_VOTE_PROJECT_CONTENT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* deleteVoteProjectContent({ payload }) {
  try {
    const { status } = yield call(api.vote.deleteVoteProjectContent, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
  } catch (error) {
    yield put({ type: types.DELETE_VOTE_PROJECT_CONTENT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* putVoteProjectPublished({ payload }) {
  try {
    const { status } = yield call(api.vote.putVoteProjectPublished, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_VOTE_PROJECT_PUBLISHED_SUCCESS, payload });
  } catch (error) {
    yield put({ type: types.PUT_VOTE_PROJECT_PUBLISHED_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* getProjectBalance({ payload }) {
  try {
    const { data, status } = yield call(api.vote.getProjectBalance, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_PROJECT_BALANCE_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_PROJECT_BALANCE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* updateProjectBalance({ payload }) {
  try {
    const { data, status } = yield call(api.vote.updateProjectBalance, payload);
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_PROJECT_BALANCE_SUCCESS });
    yield put({ type: types.GET_PROJECT_BALANCE_START });
  } catch (error) {
    yield put({ type: types.PUT_PROJECT_BALANCE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

export function* vote() {
  yield all([
    takeLatest(types.GET_VOTE_PROJECTS_START, getVoteProjects),
    takeLatest(types.GET_SINGLE_VOTE_PROJECT_START, getSingleVoteProject),
    takeLatest(types.POST_CREATE_VOTE_PROJECT_START, createVoteProject),
    takeLatest(types.UPDATE_VOTE_PROJECT_START, updateVoteProject),
    takeLatest(types.DELETE_VOTE_PROJECT_START, deleteVoteProject),
    takeLatest(types.CREATE_VOTE_PROJECT_CONTENT_START, createVoteProjectContent),
    takeLatest(types.UPDATE_VOTE_PROJECT_CONTENT_START, updateVoteProjectContent),
    takeLatest(types.DELETE_VOTE_PROJECT_CONTENT_START, deleteVoteProjectContent),
    takeLatest(types.PUT_VOTE_PROJECT_PUBLISHED_START, putVoteProjectPublished),
    takeLatest(types.GET_PROJECT_BALANCE_START, getProjectBalance),
    takeLatest(types.PUT_PROJECT_BALANCE_START, updateProjectBalance),
  ]);
}
